import * as React from "react";
import { Component } from "react";
import { stylesheet } from "typestyle";
import { layout } from "./layout.js";
import { classNames } from "./utils.js";
export class WizardProgress extends Component {
    render() {
        const { children } = this.props;
        return (React.createElement("div", { className: classNames(layout.horizontal, this.props.className) }, children));
    }
}
export class WizardStep extends Component {
    render() {
        const { children, active, title, done, fill } = this.props;
        const classes = [
            styles.stepItem,
            title && styles.stepItemTitle,
            done && styles.stepItemDone,
            active && styles.stepItemActive,
            fill && styles.stepItemFill,
        ];
        return (React.createElement("div", { className: classNames(...classes) },
            React.createElement("svg", { viewBox: "0 0 16 32", className: styles.stepTail },
                React.createElement("path", { d: "M 0 0 L 16 0 L 16 16 z" }),
                React.createElement("path", { d: "M 0 32 L 16 16 L 16 32 z" })),
            children,
            React.createElement("svg", { viewBox: "0 0 16 32", className: styles.stepHead },
                React.createElement("path", { d: "M 0 0 L 16 16 L 0 32 z" }))));
    }
}
const styles = stylesheet({
    stepItem: {
        position: "relative",
        padding: "0 1.5em",
        background: "var(--color-neutral)",
        fill: "var(--color-neutral)",
        marginRight: "1.75em",
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        minHeight: "3em",
        "$nest": {
            "&:last-child": {
                marginRight: 0,
            },
            "&:last-child svg:last-child": {
                display: "none"
            }
        }
    },
    stepItemDone: {
        backgroundColor: "var(--color-choice)",
        fill: "var(--color-choice)",
        filter: "brightness(75%)"
    },
    stepItemActive: {
        backgroundColor: "var(--color-choice)",
        fill: "var(--color-choice)"
    },
    stepItemTitle: {
        background: "var(--color-foreground)",
        fill: "var(--color-foreground)",
        color: "var(--color-background)"
    },
    stepItemFill: {
        flex: 1,
    },
    stepTail: {
        position: "absolute",
        left: 0,
        top: 0,
        width: "1.5em",
        height: "100%",
        transform: "translateX(-100%)",
    },
    stepHead: {
        position: "absolute",
        right: 0,
        top: 0,
        width: "1.5em",
        height: "100%",
        transform: "translateX(100%)",
    }
});
//# sourceMappingURL=wizard.js.map